import { useState } from 'react';

import {
  Drawer,
  DrawerProps,
  SwipeableViews,
  useDrawer,
  useDrawerInstance,
} from '@cast/design-system';

import { ClmInstanceSelection } from 'features/cluster/autoscaler/components/ClmCompatibleFamiliesPicker';

import { CompatibleInstancesSlide } from './CompatibleInstancesSlide';
import { GuideSlide } from './GuideSlide';

type Slide = 'guide' | 'compatible-instances-selection';

const SetupGuideDrawer = (drawerProps: DrawerProps) => {
  const [clmInstanceSelection, setClmInstanceSelection] = useState<
    ClmInstanceSelection | undefined
  >(undefined);
  const { close } = useDrawerInstance();
  const [activeSlide, setActiveSlide] = useState<Slide>('guide');

  return (
    <Drawer {...drawerProps} size="xlarge" testId="clm-setup-guide-drawer">
      <SwipeableViews
        sx={{ height: '100%' }}
        slidesWrapperSx={{ height: '100%' }}
        slideWrapperSx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
        animateHeight={false}
        activeSlide={activeSlide}
        onSlideChange={(slide) => setActiveSlide(slide)}
        slides={{
          guide: () => (
            <GuideSlide
              clmInstanceSelection={clmInstanceSelection}
              onOpenCompatibleInstancesDrawer={() =>
                setActiveSlide('compatible-instances-selection')
              }
              onClose={() => close()}
            />
          ),
          'compatible-instances-selection': () => (
            <CompatibleInstancesSlide
              initialClmInstanceSelection={clmInstanceSelection}
              onSave={(newSelection) => {
                setClmInstanceSelection(newSelection);
                setActiveSlide('guide');
              }}
              onCancel={() => setActiveSlide('guide')}
            />
          ),
        }}
      />
    </Drawer>
  );
};

export function useSetupGuideDrawer() {
  const { open } = useDrawer();

  return {
    openSetupGuideDrawer: () =>
      open({
        component: SetupGuideDrawer,
        props: {},
      }),
  };
}
